import React, { Component } from 'react';
import { Table } from 'reactstrap';
import { NumberKeyboard } from '../elements/NumberKeyboard'
import { DivTrain } from '../elements/DivTrain';




export class GhoreSecondPage extends Component {
    static displayName = GhoreSecondPage.name;


    constructor(props) {
        super(props);
        this.state = {};
        this.state.data = {};


        this.data2 = this.props.reverseChances;
        console.log("second page");

        this.handleTextChange = this.handleTextChange.bind(this);

        this.reverseNumberChange = this.reverseNumberChange.bind(this);

        this.sendGhore = this.sendGhore.bind(this);

        this.state.reverseChances = [];
        this.state.reverseNum = null;

        var token = localStorage.getItem('token');
        this.headers =
        {
            'Content-Type': 'application/json',
            'AuthorizationToken': token,
            ceremonyId: this.props.ceremonyId

        };
    }

    reverseNumberChange(e) {
        this.state.reverseNum = e;
     //   console.log(e.length);
      //  console.log(this.props.max.toString().length);
        if (e.length === this.props.max.toString().length)
        {
            this.setState({ reverseChances: [] })
            return;
        }
        //   if (typeof this.props.reverseNumberChange === "function") {
        //       this.props.reverseNumberChange(e);
        //  }
   
        // this.setState({});
        var d = {
            ceremonyId: this.props.ceremonyId,
            reverseNum: e
        }

        fetch('api/v1/GetReverseChance',
            {
                method: 'POST',
                body: JSON.stringify(d),
                headers: this.headers
            }).then(res => {
                this.status = res.status;


                if (this.status === 401) {
                    localStorage.setItem('token', null);
                    window.location.reload(false);

                }

                res.json().then((result) => {

                    //    console.log("status:" + this.status);

                    if (this.status === 200) {

                        //   console.log(result);
                        //  this.state.reverseChances = result;

                        this.state.isLoaded = true;
                        this.setState({ reverseChances: result });

                        //   console.log(this.state.reverseChances);

                    }
                    else {
                        // alert(result.Value);
                        //    this.setState({});
                        //window.location.href = "/ghorekeshi";
                    }

                },
                    (error) => {

                    }
                );
            }
            );
    }

    handleTextChange(data, key) {
        if (typeof this.props.handleTextChange === "function") {
            this.props.handleTextChange(data, key);
        }
    }
    sendGhore() 
    {

        if (this.state.reverseNum.length !== this.props.max.toString().length)
        {
            alert("اعداد تکمیل نشده است");
            return;
        }

        if (typeof this.props.sendGhore === "function") {
            this.props.sendGhore();
        }
    }

    componentDidMount() {
        this.reverseNumberChange("");
    }







    render() {

        var address = "/Images/" + this.props.prize.prizeImageUrl2;
        return (
            <div className="container-fluid">

            <br/>
            <br/>
                <div className="row" style={{ width: "100%", height: "80%" }}>


                    <div className="col-md-6">
                        <div className="row" style={{ height: "100%", position: "absolute", width: "100%", backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", backgroundImage: `url(${address})`, backgroundPosition: "top right" }}>
                        </div>
                    </div>
                    <div className="col-md-6" style={{ width: "100%" }}>
                        <br />
                        <Table style={{ marginTop: "10px" }}>

                            <tr className="text-center">

                                <td colSpan="2" style={{ border: 'none',fontWeight:'1000'  }} > <h3>{traverse(this.props.prize.prizeRealName)}</h3></td>
                            </tr>
                            <tr>
                                <td style={{ border: 'none' }} >تعداد شرکت کنندگان</td>
                                <td style={{ fontWeight: 'bold', border: 'none', fontSize: '32px', padding: '0px' ,margin:'0px' }}> {traverse(this.props.max)}</td>
                            </tr>

                            <tr>
                                <td> تعداد کل برندگان</td>
                                <td>{traverse(this.props.prize.cap)}</td>
                            </tr>
                            <tr>
                                <td>تعداد مانده برندگان</td>
                                <td>{traverse(this.props.prize.remain)}</td>
                            </tr>
                        </Table>





                        <div className="align-items-center" style={{ width: "100%" }}>
                            <NumberKeyboard max={this.props.max} reverseNum={this.state.reverseNum} reverseNumberChange={this.reverseNumberChange} handleTextChange={this.handleTextChange} />
                        </div>









                        <div className="row">

                            <div className="col-md-1">
                            </div>
                            <div className="col-md-10">
                                <input type="button" className="btn btn-warning" style={{ width: "100%", marginTop: "20px", fontSize: "40px", padding: "10px", background: "#FFFF00" }} value="قرعه کشی" onClick={this.sendGhore} />
                            </div>
                            <div className="col-md-1">
                            </div>
                        </div>
                    </div>


                    <div className="w-100"> </div>

                    <div className="row" style={{ width: "100%" }}>
                        <DivTrain reverseChances={this.state.reverseChances} reverseNum={this.state.reverseNum}></DivTrain>
                    </div>

                </div>


            </div>


        );
    }
}
const persian = { 0: '۰', 1: '۱', 2: '۲', 3: '۳', 4: '۴', 5: '۵', 6: '۶', 7: '۷', 8: '۸', 9: '۹' };
function traverse(el) {
    el = el.toString();
    var list = el.match(/[0-9]/g);
    if (list != null && list.length !== 0) {
        for (var i = 0; i < list.length; i++)
            el = el.replace(list[i], persian[list[i]]);
    }
    return el;


}


// WEBPACK FOOTER //
// ./src/components/GhoreSecondPage.js